import CompanyManagement from '../pages/AdminSetting/CompanyManagement';
import EmailTemplate from '../pages/AdminSetting/EmailTemplate';
import Person from '../pages/AdminSetting/Person';
// import Exchange24hour from '../pages/Exchange24hour';
// import GateGroup from '../pages/GateGroup';
// import GateLock from '../pages/GateLock';
import Gate from '../pages/AdminSetting/Gate';
import SystemManagement from '../pages/AdminSetting/SystemManagement';
import ControlInOut from '../pages/ControlInOut';
// import OvertimeControlInOut from '../pages/OvertimeControlInOut';
import OvertimeRequest from '../pages/OvertimeRequest';
import OvertimeRequestForRequester from '../pages/OvertimeRequestForRequester';

import Blacklist from '../pages/Report/Blacklist';
// import ConnectionStatus from '../pages/AdminSetting/ConnectionStatus';
import EmergencyStructurePlan from '../pages/Report/EmergencyStructurePlan';
// import InOutEachGate from '../pages/Report/InOutEachGate';
// import InOutPrivilegeEachGate from '../pages/Report/InOutPrivilegeEachGate';
import InProductionProcess from '../pages/Report/InProductionProcess';
import NumberInOut from '../pages/Report/NumberInOut';
import ReportInPeople from '../pages/Report/ReportInPeople';
import ReportTempPeople from '../pages/Report/ReportTempPeople';
import SummaryWorkingTime from '../pages/Report/SummaryWorkingTime';
// import WorkingPeople from '../pages/Report/WorkingPeople';
import SummaryInOut from '../pages/SummaryInOut';
import InOut from '../pages/SummaryInOut/InOut';
import TrackingCard from '../pages/AdminSetting/TrackingCard';
import ExchangeCard from '../pages/AdminSetting/ExchangeCard';
import Map from '../pages/AdminSetting/Map';
import ScanConnectionStatus from '../pages/AdminSetting/ScanConnectionStatus';

import AreaPage from '../pages/AdminSetting/Area';
import CreateBlacklist from '../pages/Report/Blacklist/CreateBlacklist';
import BlacklistEdit from '../pages/Report/Blacklist/BlacklistEdit';
import BlacklistCompanyEdit from '../pages/Report/Blacklist/BlacklistCompanyEdit';
import CreateOTRequest from '../pages/OvertimeRequest/CreateOTRequest';
import ControlInDetail from '../pages/ControlInOut/ControlInDetail';
import ControlOutDetail from '../pages/ControlInOut/ControlOutDetail';
// import OvertimeControlInDetail from '../pages/OvertimeControlInOut/OvertimeControlInDetail';
import CreateArea from '../pages/AdminSetting/Area/CreateArea';
import EditArea from '../pages/AdminSetting/Area/EditArea';
import GateGroup from '../pages/AdminSetting/GateGroup';
import CreateGateGroup from '../pages/AdminSetting/GateGroup/CreateGateGroup';
import EditGateGroup from '../pages/AdminSetting/GateGroup/EditGateGroup';
import CreateGate from '../pages/AdminSetting/Gate/CreateGate';
import EditGate from '../pages/AdminSetting/Gate/EditGate';
import PersonDetail from '../pages/AdminSetting/Person/PersonDetail';
import EditPerson from '../pages/AdminSetting/Person/EditPerson';
import CreateCompany from '../pages/AdminSetting/CompanyManagement/CreateCompany';
import CompanyDetail from '../pages/AdminSetting/CompanyManagement/CompanyDetail';
import EditCompany from '../pages/AdminSetting/CompanyManagement/EditCompany';
import CreateEmailTemplate from '../pages/AdminSetting/EmailTemplate/CreateEmailTemplate';
import EmailTemplateDetail from '../pages/AdminSetting/EmailTemplate/EmailTemplateDetail';
import EditEmailTemplate from '../pages/AdminSetting/EmailTemplate/EditEmailTemplate';
import CreateCard from '../pages/AdminSetting/ExchangeCard/CreateCard';
import EditCard from '../pages/AdminSetting/ExchangeCard/EditCard';

import UserRoleManagement from '../pages/AdminSetting/UserRoleManagement';
import UserRoleEdit from '../pages/AdminSetting/UserRoleManagement/UserRoleEdit';

import UserManagement from '../pages/AdminSetting/UserManagement';
import UserCreate from '../pages/AdminSetting/UserManagement/UserCreate';
import UserEdit from '../pages/AdminSetting/UserManagement/UserEdit';

import { Roles } from '../schema/user';
import PMTDetail from '../pages/AdminSetting/TrackingCard/PMTDetail';
import VHMDetail from '../pages/AdminSetting/TrackingCard/VHMDetail';

import CCTVreport from '../pages/Report/CCTVreport';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faPersonWalkingDashedLineArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faVirusCovid } from '@fortawesome/free-solid-svg-icons';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';

import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import TransferWithinAStationOutlinedIcon from '@mui/icons-material/TransferWithinAStationOutlined';
// import Face5Icon from '@mui/icons-material/Face5';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import FactoryIcon from '@mui/icons-material/Factory';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import BlockIcon from '@mui/icons-material/Block';
import BadgeIcon from '@mui/icons-material/Badge';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import StyleIcon from '@mui/icons-material/Style';
import WifiTetheringIcon from '@mui/icons-material/WifiTethering';


// ==============================|| MENU ITEMS ||============================== //
export interface MenuItemType {
  id: string;
  title?: string;
  type?: 'collapse' | 'item' | 'hidden';
  url?: string;
  // icon: icons.IconHelp;
  external?: boolean;
  target?: boolean;
  children?: MenuItemType[];
  permission?: Roles[];
  component?: JSX.Element;
  iconElement?: JSX.Element;
}

const menuItems: {
  items: MenuItemType[];
} = {
  items: [
    {
      id: 'summary-in-out',
      title: 'สรุปจำนวนคนเข้า - ออกพื้นที่',
      type: 'item',
      url: '/summary-in-out',
      component: <SummaryInOut />,
      iconElement: <HomeIcon />
    },
    {
      id: 'summary-in-out/table',
      title: 'ข้อมูลการแลกบัตรล่าสุด',
      type: 'hidden',
      url: '/summary-in-out/table',
      component: <InOut />
    },
    {
      id: 'control-in-out',
      title: 'การควบคุมบุคคล เข้า-ออก',
      type: 'item',
      url: '/control-in-out',
      permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
      component: <ControlInOut />,
      iconElement: <FontAwesomeIcon icon={faPersonWalkingDashedLineArrowRight} />
    },
    {
      id: 'control-in-out/in/:person_id',
      title: 'การควบคุมบุคคล เข้า-ออก (เข้า)',
      type: 'hidden',
      url: '/control-in-out/in/:person_id',
      permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
      component: <ControlInDetail />
    },
    {
      id: 'control-in-out/out/:person_id',
      title: 'การควบคุมบุคคล เข้า-ออก (ออก)',
      type: 'hidden',
      url: '/control-in-out/out/:person_id',
      permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
      component: <ControlOutDetail />
    },
    // {
    //   id: 'overtime-control-in-out',
    //   title: 'แลกบัตรล่วงเวลา',
    //   type: 'item',
    //   url: '/overtime-control-in-out',
    //   permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
    //   component: <OvertimeControlInOut />
    // },
    // {
    //   id: 'overtime-control-in-out/in/:person_id',
    //   title: 'แลกบัตรล่วงเวลา',
    //   type: 'hidden',
    //   url: '/overtime-control-in-out/in/:person_id',
    //   permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
    //   component: <OvertimeControlInDetail />
    // },
    // {
    //   id: 'requester-overtime-request',
    //   title: 'ขอแลกบัตรล่วงเวลา (Requester)',
    //   type: 'item',
    //   url: '/requester-overtime-request',
    //   permission: [Roles.Requester],
    //   component: <OvertimeRequestForRequester />,
    //   iconElement: <MoreTimeOutlinedIcon />
    // },
    // {
    //   id: 'overtime-request',
    //   title: 'ขอแลกบัตรล่วงเวลา',
    //   type: 'item',
    //   url: '/overtime-request',
    //   permission: [Roles.Admin, Roles.Security, Roles.Supervisor],
    //   component: <OvertimeRequest />,
    //   iconElement: <MoreTimeOutlinedIcon />
    // },
    // {
    //   id: 'overtime-request/create',
    //   title: 'ขอแลกบัตรล่วงเวลา (สร้าง)',
    //   type: 'hidden',
    //   url: '/overtime-request/create',
    //   component: <CreateOTRequest />
    // },
    {
      id: 'follow-and-report',
      title: 'ติดตาม และ รายงาน',
      type: 'collapse',
      iconElement: <BarChartOutlinedIcon />,
      children: [
        {
          id: 'number-in-out',
          title: 'จำนวนบุคคลเข้า-ออก',
          type: 'item',
          url: '/number-in-out',
          permission: [Roles.Admin],
          component: <NumberInOut />,
          iconElement: <TransferWithinAStationOutlinedIcon />
        },
        {
          id: 'cctv-report',
          title: 'รายงานแสกนใบหน้า',
          type: 'item',
          url: '/cctv-report',
          permission: [Roles.Admin],
          component: <CCTVreport />,
          iconElement: <TransferWithinAStationOutlinedIcon />
        },
        // {
        //   id: 'in-out-each-gate',
        //   title: 'คนเข้า-ออกแต่ละประตู',
        //   type: 'item',
        //   url: '/in-out-each-gate',
        //   permission: [Roles.Admin],
        //   component: <InOutEachGate />
        // },
        // {
        //   id: 'in-out-privilege-each-gate',
        //   title: 'สิทธิการผ่านเข้า-ออกแต่ละประตู',
        //   type: 'item',
        //   url: '/in-out-privilege-each-gate',
        //   permission: [Roles.Admin],
        //   component: <InOutPrivilegeEachGate />
        // },
        {
          id: 'in-production-process',
          title: 'บุคคลในพื้นที่กระบวนการผลิต',
          type: 'item',
          url: '/in-production-process',
          permission: [Roles.Admin, Roles.Supervisor],
          component: <InProductionProcess />,
          iconElement: <FactoryIcon />
        },
        {
          id: 'emergency-structure-plan',
          title: 'แผนโครงสร้างฉุกเฉิน',
          type: 'item',
          url: '/emergency-structure-plan',
          // see all
          component: <EmergencyStructurePlan />,
          iconElement: <FontAwesomeIcon icon={faPersonCircleExclamation} />
        },
        {
          id: 'summary-working-time',
          title: 'สรุปชั่วโมงการทำงาน',
          type: 'item',
          url: '/summary-working-time',
          permission: [Roles.Admin, Roles.Supervisor],
          component: <SummaryWorkingTime />,
          iconElement: <WorkHistoryIcon />
        },
        // {
        //   id: 'in-out-gate',
        //   title: 'การเข้าผ่านประตู',
        //   type: 'item',
        //   url: '/in-out-gate'
        // },
        // {
        //   id: 'card-exchange-return',
        //   title: 'แลกบัตร/คืนบัตร',
        //   type: 'item',
        //   url: '/card-exchange-return'
        // },
        {
          id: 'blacklist',
          title: 'Blacklist',
          type: 'item',
          url: '/blacklist',
          component: <Blacklist />,
          iconElement: <BlockIcon />
        },
        {
          id: 'blacklist/create',
          title: 'Blacklist (create)',
          type: 'hidden',
          url: '/blacklist/create',
          component: <CreateBlacklist />,
          iconElement: <BlockIcon />
        },
        {
          id: 'blacklist/:person_id/edit',
          title: 'Blacklist (edit)',
          type: 'hidden',
          url: '/blacklist/:person_id/edit',
          component: <BlacklistEdit />,
          iconElement: <BlockIcon />
        },
        {
          id: 'blacklist_company/:company_id/edit',
          title: 'Blacklist Company (edit)',
          type: 'hidden',
          url: '/blacklist_company/:company_id/edit',
          component: <BlacklistCompanyEdit />,
          iconElement: <BlockIcon />
        },
        // {
        //   id: 'working-people',
        //   title: 'บุคคลที่อยู่ในระยะเวลาทำงาน',
        //   type: 'item',
        //   url: '/working-people',
        //   permission: [Roles.Admin, Roles.Supervisor],
        //   component: <WorkingPeople />
        // },
        {
          id: 'report-in-people',
          title: 'บุคคลที่ไม่ได้แลกบัตรออก',
          type: 'item',
          url: '/report-in-people',
          permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
          component: <ReportInPeople />,
          iconElement: <BadgeIcon />
        },
        {
          id: 'report-covid-people',
          title: 'รายงานการตรวจ Covid-19',
          type: 'item',
          url: '/report-covid-people',
          permission: [Roles.Admin, Roles.Supervisor, Roles.Security],
          component: <ReportTempPeople />,
          iconElement: <FontAwesomeIcon icon={faVirusCovid} />
        },
        {
          id: 'person',
          title: 'รายงานบุคคลในระบบ',
          type: 'item',
          url: '/person',
          permission: [Roles.Admin],
          component: <Person />,
          iconElement: <GroupsIcon />
        },
        {
          id: 'person/:person_id',
          title: 'รายงานบุคคลในระบบ (ข้อมูล)',
          type: 'hidden',
          url: '/person/:person_id',
          permission: [Roles.Admin],
          component: <PersonDetail />,
          iconElement: <GroupsIcon />
        },
        {
          id: 'person/:person_id/edit',
          title: 'รายงานบุคคลในระบบ (แก้ไข)',
          type: 'hidden',
          url: '/person/:person_id/edit',
          permission: [Roles.Admin],
          component: <EditPerson />,
          iconElement: <GroupsIcon />
        }
      ]
    },
    {
      id: 'admin-menu',
      title: 'ตั้งค่าระบบ',
      type: 'collapse',
      permission: [Roles.Admin],
      iconElement: <SettingsOutlinedIcon />,
      children: [
        {
          id: 'area',
          title: 'พื้นที่',
          type: 'item',
          url: '/area',
          component: <AreaPage />,
          iconElement: <FontAwesomeIcon icon={faLocationDot} />
        },
        {
          id: 'area/create',
          title: 'พื้นที่ (สร้าง)',
          type: 'hidden',
          url: '/area/create',
          component: <CreateArea />
        },
        {
          id: 'area/:area_id/edit',
          title: 'พื้นที่ (แก้ไข)',
          type: 'hidden',
          url: '/area/:area_id/edit',
          component: <EditArea />
        },
        {
          id: 'gate',
          title: 'ประตู',
          type: 'item',
          url: '/gate',
          component: <Gate />,
          iconElement: <SensorDoorIcon />
        },
        // {
        //   id: 'gate/create',
        //   title: 'ประตู (สร้าง)',
        //   type: 'hidden',
        //   url: '/gate/create',
        //   component: <CreateGate />
        // },
        {
          id: 'gate/:gate_id/edit',
          title: 'ประตู (แก้ไข)',
          type: 'hidden',
          url: '/gate/:gate_id/edit',
          component: <EditGate />
        },
        {
          id: 'gate-group',
          title: 'กลุ่มประตู',
          type: 'item',
          url: '/gate-group',
          component: <GateGroup />,
          iconElement: <WorkspacesIcon />
        },
        {
          id: 'gate-group/create',
          title: 'กลุ่มประตู (สร้าง)',
          type: 'hidden',
          url: '/gate-group/create',
          component: <CreateGateGroup />
        },
        {
          id: 'gate-group/:gate_group_id/edit',
          title: 'กลุ่มประตู (แก้ไข)',
          type: 'hidden',
          url: '/gate-group/:gate_group_id/edit',
          component: <EditGateGroup />
        },
        {
          id: 'email-management',
          title: 'รูปแบบ E-mail',
          type: 'item',
          url: '/email-management',
          component: <EmailTemplate />,
          iconElement: <FontAwesomeIcon icon={faEnvelopesBulk} />
        },
        {
          id: 'email-management/create',
          title: 'รูปแบบ E-mail (สร้าง)',
          type: 'hidden',
          url: '/email-management/create',
          component: <CreateEmailTemplate />
        },
        {
          id: 'email-management/:email_template_id',
          title: 'รูปแบบ E-mail (ข้อมูล)',
          type: 'hidden',
          url: '/email-management/:email_template_id',
          component: <EmailTemplateDetail />
        },
        {
          id: 'email-management/:email_template_id/edit',
          title: 'รูปแบบ E-mail (แก้ไข)',
          type: 'hidden',
          url: '/email-management/:email_template_id/edit',
          component: <EditEmailTemplate />
        },
        {
          id: 'company-management',
          title: 'จัดการข้อมูลบริษัท',
          type: 'item',
          url: '/company-management',
          component: <CompanyManagement />,
          iconElement: <FontAwesomeIcon icon={faBuilding} />
        },
        {
          id: 'company-management/create',
          title: 'จัดการข้อมูลบริษัท (สร้าง)',
          type: 'hidden',
          url: '/company-management/create',
          component: <CreateCompany />
        },
        {
          id: 'company-management/:company_id',
          title: 'จัดการข้อมูลบริษัท (ข้อมูล)',
          type: 'hidden',
          url: '/company-management/:company_id',
          component: <CompanyDetail />
        },
        {
          id: 'company-management/:company_id/edit',
          title: 'จัดการข้อมูลบริษัท (แก้ไข)',
          type: 'hidden',
          url: '/company-management/:company_id/edit',
          component: <EditCompany />
        },
        {
          id: 'system-management',
          title: 'เมนูระบบการจัดการข้อมูล',
          type: 'item',
          url: '/system-management',
          component: <SystemManagement />,
          iconElement: <FontAwesomeIcon icon={faDatabase} />
        },
        {
          id: 'tracking-card',
          title: 'หมายเลขอุปกรณ์ติดตาม',
          type: 'item',
          url: '/tracking-card',
          component: <TrackingCard />,
          iconElement: <ShareLocationIcon />
        },
        {
          id: 'tracking-card/PMT/:id',
          title: 'อุปกรณ์ติดตามบุคคล',
          type: 'hidden',
          url: '/tracking-card/PMT/:id',
          component: <PMTDetail />
        },
        {
          id: 'tracking-card/VHM/:id',
          title: 'อุปกรณ์ติดตามพาหนะ',
          type: 'hidden',
          url: '/tracking-card/VHM/:id',
          component: <VHMDetail />
        },
        // {
        //   id: 'card',
        //   title: 'บัตรแลกเข้า',
        //   type: 'item',
        //   url: '/card',
        //   component: <ExchangeCard />,
        //   iconElement: <StyleIcon />
        // },
        // {
        //   id: 'card/create',
        //   title: 'บัตรแลกเข้า (สร้าง)',
        //   type: 'hidden',
        //   url: '/card/create',
        //   component: <CreateCard />
        // },
        // {
        //   id: 'card/:card_id/edit',
        //   title: 'บัตรแลกเข้า (แก้ไข)',
        //   type: 'hidden',
        //   url: '/card/:card_id/edit',
        //   component: <EditCard />
        // },
        // {
        //   id: 'connection-status',
        //   title: 'ตรวจสอบสถานะเชื่อมต่อ',
        //   type: 'item',
        //   url: '/connection-status',
        //   permission: [Roles.Admin, Roles.Supervisor],
        //   component: <ConnectionStatus />
        // },
        // {
        //   id: 'report',
        //   title: 'แสดงรายงาน',
        //   type: 'item',
        //   url: '/report',
        //   permission: [Roles.Admin],
        //   component: <Report />
        // },
        {
          id: 'map',
          title: 'แผนที่',
          type: 'item',
          url: '/map',
          permission: [Roles.Admin],
          component: <Map />,
          iconElement: <FontAwesomeIcon icon={faMapLocationDot} />
        },
        {
          id: 'scan-connection-status',
          title: 'สถานะเชื่อมต่อเครื่องสแกน',
          type: 'item',
          url: '/scan-connection-status',
          permission: [Roles.Admin],
          component: <ScanConnectionStatus />,
          iconElement: <WifiTetheringIcon />
        },
        // {
        //   id: 'user',
        //   title: 'User',
        //   type: 'item',
        //   url: '/user',
        //   permission: [Roles.Admin],
        //   component: <UserManagement />,
        //   iconElement: <FontAwesomeIcon icon={faCircleUser} />
        // },
        {
          id: 'user/create',
          title: 'เพิ่ม User',
          type: 'hidden',
          url: '/user/create',
          permission: [Roles.Admin],
          component: <UserCreate />
        },
        {
          id: 'user/:user_id/edit',
          title: 'แก้ไข User',
          type: 'hidden',
          url: '/user/:user_id/edit',
          permission: [Roles.Admin],
          component: <UserEdit />
        },
        {
          id: 'user-role-management',
          title: 'User Role',
          type: 'item',
          url: '/user-role-management',
          permission: [Roles.Admin],
          component: <UserRoleManagement />,
          iconElement: <FontAwesomeIcon icon={faCircleUser} />
        },
        {
          id: 'user-role/create',
          title: 'เพิ่ม User Role',
          type: 'hidden',
          url: '/user-role/create',
          permission: [Roles.Admin],
          component: <UserRoleEdit />
        },
        {
          id: 'user-role/:user_role_id/edit',
          title: 'แก้ไข User Role',
          type: 'hidden',
          url: '/user-role/:user_role_id/edit',
          permission: [Roles.Admin],
          component: <UserRoleEdit />
        }
      ]
    }
  ]
};

export default menuItems;
